var _defs, _circle, _g, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.461,
    height: 39.461,
    "data-name": "Group 154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.139,
    x2: 0.834,
    y1: 0.139,
    y2: 0.834,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#5c0cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2979ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1fcbff"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.731,
    cy: 19.731,
    r: 19.731,
    fill: "url(#a)",
    "data-name": "Ellipse 7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 153"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.924 13.833a9.9 9.9 0 0 0-2.871-4.148 8.24 8.24 0 0 0-3.56-1.738 20.3 20.3 0 0 0-4.321-.348h-6.927a1.43 1.43 0 0 0-1.432 1.432 1.43 1.43 0 0 0 1.432 1.432h6.878a12.6 12.6 0 0 1 4.155.5 6.3 6.3 0 0 1 3.037 2.74 11.3 11.3 0 0 1 1.25 5.851 15 15 0 0 1-.638 4.676 7.65 7.65 0 0 1-1.778 3.071 5.4 5.4 0 0 1-2.177 1.259 12.6 12.6 0 0 1-3.767.446h-5.053a.127.127 0 0 1-.127-.127V17.698a1.43 1.43 0 0 0-1.432-1.432h-.348a1.43 1.43 0 0 0-1.432 1.432v13.667a.5.5 0 0 0 .5.5h8.257a16.5 16.5 0 0 0 3.9-.414 9 9 0 0 0 2.9-1.217 8.8 8.8 0 0 0 2.211-2.2 11.9 11.9 0 0 0 1.654-3.536 16.9 16.9 0 0 0 .647-4.9 16.2 16.2 0 0 0-.958-5.765",
    "data-name": "Path 37"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.623,
    cy: 1.623,
    r: 1.623,
    fill: "#fff",
    "data-name": "Ellipse 8",
    transform: "translate(10.814 11.74)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logoSM.543c49cb32fc9a0f97bbf8af80b4b686.svg";
export { ForwardRef as ReactComponent };